import { PowerCard } from "./PowerCard";
export default PowerCard;
